import React from 'react';
import { Navigate, Outlet, RouteObject } from 'react-router';

import * as ValleyBankEntityConfig from './EntityConfig';
import { LogoutOnUserInactivity } from '~/contexts/UserAuthProvider';
import { PermissionGuard } from '~/core/PermissionGuard';
import { Route as AdvanceRateRoute } from '~/core/routes/valley-bank/advance-rate/_index';
import { Route as ArrangementGroupsRoute } from '~/core/routes/valley-bank/arrangement-groups/_index';
import { Route as AssignmentRoute } from '~/core/routes/valley-bank/assignment/_index';
import { Router as CustomersRouter } from '~/core/routes/valley-bank/customers/Router';
import { Router as LoanAccountsRouter } from '~/core/routes/valley-bank/loan-accounts/Router';
import { ValleyBankLayout } from '~/core/routes/valley-bank/ValleyBankLayout';
import { CreditFacilityProvider } from '~/packages/credit-facility/hooks/CreditFacilityProvider';
import { DataMetadataProvider } from '~/valleyBank/domains/page/hooks/DataMetadataContext';
import { UserRoleTypePremissionsProvider } from '~/valleyBank/domains/page/hooks/useUserRoleTypePermissions';
import { ValleyBankDataMedataHeader } from '~/valleyBank/domains/page/ui/ValleyBankDataMedataHeader';

// Exports
export const Router: RouteObject = {
  element: (
    <PermissionGuard
      permissions={ValleyBankEntityConfig.permissions}
      fallback={<Navigate to="/" replace />}
    >
      <LogoutOnUserInactivity>
        <UserRoleTypePremissionsProvider>
          <DataMetadataProvider>
            <ValleyBankDataMedataHeader />
            <ValleyBankLayout>
              <CreditFacilityProvider>
                <Outlet />
              </CreditFacilityProvider>
            </ValleyBankLayout>
          </DataMetadataProvider>
        </UserRoleTypePremissionsProvider>
      </LogoutOnUserInactivity>
    </PermissionGuard>
  ),
  // Relative to /valley-bank/*
  children: [
    { path: 'advance-rate', element: <AdvanceRateRoute /> },
    { path: 'arrangement-groups', element: <ArrangementGroupsRoute /> },
    { path: 'assignment', element: <AssignmentRoute /> },
    { path: 'customers/*', children: [CustomersRouter] },
    { path: 'loan-accounts/*', children: [LoanAccountsRouter] },
    { path: '*', element: <Navigate to="./loan-accounts" replace /> },
  ],
};
